export const projects = [
  {
    id: 1,
    image: "images/cctv/cctv-1.png",
    name: "Vision Group",
    location: "Gandhinagar",
    description: "Total ELV solution / includes CCTV, Fire, EPABX, networking.",
    about:
      "Vision Group offers a comprehensive ELV (Extra Low Voltage) solution, including a wide array of services such as CCTV installation, fire alarm systems, EPABX (Electronic Private Automatic Branch Exchange) systems, and robust networking solutions. Their project involves intricate wiring, device configurations, and system integration to ensure top-notch safety and communication across their premises.",
  },
  {
    id: 2,
    image: "images/cctv/cctv-2.png",
    name: "Shyam Group",
    location: "Ahmedabad",
    description:
      "Total networking solution & 150 Cisco Wireless Access Point & kiosk work.",
    about:
      "Shyam Group required a total networking solution for their office and campus setup, involving the installation of 150 Cisco Wireless Access Points. Additionally, the project included the setup of kiosk systems for interactive customer service. The project aimed to create a seamless network infrastructure for employees and customers alike, ensuring strong, reliable connectivity across various office zones and public areas.",
  },
  {
    id: 3,
    image: "images/cctv/cctv-3.png",
    name: "KBC Group",
    location: "South Bopal",
    description:
      "Audio Video solution for classroom, conference room, computer lab.",
    about:
      "KBC Group's project involved the installation of advanced Audio-Video (AV) solutions for educational and corporate settings. This included setting up AV systems in classrooms, conference rooms, and computer labs to provide high-quality audio, video, and connectivity for presentations, meetings, and online learning. The setup was designed to facilitate smooth communication and an immersive learning experience.",
  },
  {
    id: 4,
    image: "images/cctv/cctv-4.png",
    name: "Evergreen Group",
    location: "Ahmedabad",
    description: "Total ELV solution / includes CCTV, Fire, EPABX, networking.",
    about:
      "Evergreen Group undertook a comprehensive ELV solution project, similar to that of Vision Group, focusing on cutting-edge safety and communication technologies. The scope of work included the design, installation, and maintenance of CCTV systems, fire alarms, EPABX systems, and networking solutions across the group's various facilities, ensuring the integration of systems for optimal performance and security.",
  },
  {
    id: 5,
    image: "images/cctv/cctv-5.png",
    name: "Sillicon Velly",
    location: "Ahmedabad",
    description:
      "Total networking solution & 150 Cisco Wireless Access Point & kiosk work.",
    about:
      "Silicon Valley's project was centered around providing advanced networking solutions for their sprawling campus. This included the installation of 150 Cisco Wireless Access Points to ensure seamless connectivity for employees, along with setting up kiosk systems to engage with visitors and clients. The project was designed to handle high traffic and deliver fast, secure, and reliable network access throughout the premises.",
  },
  {
    id: 6,
    image: "images/cctv/cctv-6.png",
    name: "Swaminarayn Group",
    location: "Ahmedabad",
    description:
      "Audio Video solution for classroom, conference room, computer lab.",
    about:
      "Swaminarayan Group’s project revolved around enhancing their learning and meeting spaces with sophisticated AV solutions. Classrooms, conference rooms, and computer labs were equipped with high-definition audio and video equipment, ensuring clear communication during lectures, meetings, and conferences. The system integration also included seamless connectivity for streaming, presentations, and collaborative activities.",
  },
  {
    id: 7,
    image: "images/cctv/cctv-2.png",
    name: "Ramani Corporate",
    location: "Ahmedabad",
    description:
      "AV setup for corporate training and collaboration rooms.",
    about:
      "Ramani Corporate required a complete upgrade of their training and meeting infrastructure. We provided a tailored audio-video setup including smart displays, wireless presentation systems, and acoustic enhancements. The result was a seamless environment for corporate presentations, online meetings, and interactive training sessions.",
  },
  {
    id: 8,
    image: "images/cctv/cctv-4.png",
    name: "Ramani Developer",
    location: "Ahmedabad",
    description:
      "AV solutions for workspaces and client presentations.",
    about:
      "For Ramani Developer, our team designed and implemented a high-quality audio-video solution focused on enhancing daily operations and client engagements. The installation included large-format displays, integrated sound systems, and intuitive control panels to ensure every meeting and presentation runs efficiently and professionally.",
  }  
];
